import { useState } from 'react'
import { studentReviews, renderStars } from '@/data/homeReviews'
import { Container, SectionHeading } from '@/components/ui'

const HIGHLIGHTS = [
  'Mentor kèm sát, chữa bài chi tiết',
  'Lộ trình rõ từ BA nền tảng đến AI',
  'Cộng đồng hỗ trợ sau khóa học',
]

const EaseReviews = () => {
  const [expandedReviews, setExpandedReviews] = useState<Record<number, boolean>>({})
  const [showAllReviews, setShowAllReviews] = useState(false)
  const [featuredExpanded, setFeaturedExpanded] = useState(false)
  const featured = studentReviews[0]
  const list = studentReviews.slice(0, showAllReviews ? studentReviews.length : 6)

  const truncateText = (text: string, maxLength = 150) => {
    if (text.length <= maxLength) return text
    return text.substring(0, maxLength) + '...'
  }

  return (
    <section className="eh-section" id="reviews">
      <Container>
        <div className="eh-reveal mb-8 md:mb-10">
          <SectionHeading
            eyebrow="Đánh giá của học viên"
            level="title"
            title="Kết Quả Học Viên Nhận Được Sau Khi Học"
            description="Những chia sẻ thực tế từ học viên đã dùng M2MBA để chuyển ngành, tăng hiệu suất làm BA và mở rộng sang AI, hệ thống, sản phẩm."
          />
        </div>

        {featured?.review && (
          <div className="eh-reveal mb-8 grid gap-8 border-y border-eh-border py-8 lg:grid-cols-[1.2fr_0.8fr] lg:gap-12">
            <blockquote>
              <p className="eh-title max-w-[610px] text-eh-forest-ink">
                “
                {featuredExpanded
                  ? featured.review
                  : truncateText(featured.review, 180)}
                ”
              </p>
              {featured.review.length > 180 && (
                <button
                  type="button"
                  onClick={() => setFeaturedExpanded((prev) => !prev)}
                  className="mt-4 text-sm font-medium text-eh-forest-ink underline"
                >
                  {featuredExpanded ? 'Thu gọn' : 'Xem thêm'}
                </button>
              )}
              <div className="mt-8 flex items-center gap-3.5">
                <div className="grid h-12 w-12 place-items-center rounded-full bg-eh-sage text-sm font-semibold text-eh-forest-ink">
                  {featured.avatar || featured.fullName.slice(0, 2)}
                </div>
                <div>
                  <p className="font-semibold text-eh-forest-ink">{featured.fullName}</p>
                  <p className="text-eh-caption">{featured.course}</p>
                </div>
              </div>
            </blockquote>
            <div className="eh-divider-list" role="list">
              {HIGHLIGHTS.map((text, i) => (
                <div key={text} className="eh-divider-list__item" role="listitem">
                  <span className="eh-display text-2xl text-eh-forest-ink">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <p className="mt-2 text-lg font-light leading-snug text-eh-forest-ink md:text-xl">
                    {text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="eh-stagger mt-2 grid grid-cols-1 gap-0 border-t border-eh-border sm:grid-cols-2 lg:grid-cols-3">
          {list.map((review) => (
            <article
              key={review.id}
              className="eh-reveal flex flex-col justify-between border-b border-eh-border p-5 sm:border-r sm:odd:border-l-0 lg:[&:nth-child(3n)]:border-r-0"
            >
              <div>
                <p className="text-sm font-semibold text-eh-forest-ink">
                  {review.fullName} — {review.course}
                </p>
                <div className="mb-4 mt-3 flex items-center">
                  <div className="flex items-center">{renderStars(review.rating)}</div>
                  <span className="ml-2 text-sm text-eh-muted">({review.rating}/5)</span>
                </div>
                {review.review ? (
                  <div className="text-sm leading-relaxed text-eh-charcoal">
                    <p>
                      “
                      {expandedReviews[review.id]
                        ? review.review
                        : truncateText(review.review)}
                      ”
                    </p>
                    {review.review.length > 150 && (
                      <button
                        type="button"
                        onClick={() =>
                          setExpandedReviews((prev) => ({
                            ...prev,
                            [review.id]: !prev[review.id],
                          }))
                        }
                        className="mt-2 text-sm font-medium text-eh-forest-ink underline"
                      >
                        {expandedReviews[review.id] ? 'Thu gọn' : 'Xem thêm'}
                      </button>
                    )}
                  </div>
                ) : (
                  <p className="text-sm italic text-eh-muted">
                    Học viên chưa để lại đánh giá chi tiết.
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>

        {studentReviews.length > 6 && (
          <div className="mt-10 text-center">
            <button
              type="button"
              onClick={() => setShowAllReviews(!showAllReviews)}
              className="eh-btn-secondary"
            >
              {showAllReviews
                ? 'Thu gọn đánh giá'
                : `Xem thêm ${studentReviews.length - 6} đánh giá`}
            </button>
          </div>
        )}
      </Container>
    </section>
  )
}

export default EaseReviews
